namespace RioERP.Masters {
    export interface SmtpSettingsRow {
        Id?: number;
        ServerAddress?: string;
        FromName?: string;
        FromEmail?: string;
        UserName?: string;
        Password?: string;
        Port?: number;
        IsActive?: number;
        IsAws?: boolean;
        SendEmailOnWebsiteSync?: boolean;
        UseApi?: boolean;
        ApiProvider?: string;
        ApiKey?: string;
    }

    export namespace SmtpSettingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ServerAddress';
        export const localTextPrefix = 'Masters.SmtpSettings';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ServerAddress = "ServerAddress",
            FromName = "FromName",
            FromEmail = "FromEmail",
            UserName = "UserName",
            Password = "Password",
            Port = "Port",
            IsActive = "IsActive",
            IsAws = "IsAws",
            SendEmailOnWebsiteSync = "SendEmailOnWebsiteSync",
            UseApi = "UseApi",
            ApiProvider = "ApiProvider",
            ApiKey = "ApiKey"
        }
    }
}
